module.exports = __webpack_public_path__ + "static/media/DSC_3554.db9205df.jpg";